import { auth } from "./firebase.service"
import { withCalendarRepair } from "../utils/calendar.utils"

// La coda del calendario sta sul telefono (`localStorage`), una per accesso:
// sopravvive all'app chiusa, e chi entra con un altro account non si
// ritrova le operazioni di qualcun altro. Cosa c'è dentro lo dice
// `withCalendarRepair` in utils/calendar.utils.js; chi la svuota è
// services/calendarSync.service.js.
const QUEUE_STORAGE_KEY = "incampo.calendarQueue"

// dopo tanti errori che non sono di rete, riprovare non serve più
export const MAX_CALENDAR_ATTEMPTS = 5

const storageKey = uid => `${QUEUE_STORAGE_KEY}.${uid}`

export const readCalendarQueue = uid => {
	try {
		const queue = JSON.parse(window.localStorage.getItem(storageKey(uid)) ?? "[]")
		return Array.isArray(queue) ? queue : []
	} catch {
		return []
	}
}

const writeCalendarQueue = (uid, queue) => {
	try {
		if (queue.length > 0) window.localStorage.setItem(storageKey(uid), JSON.stringify(queue))
		else window.localStorage.removeItem(storageKey(uid))
	} catch {
		// navigazione privata: resta il controllo di ogni giorno
	}
}

let lastEntryID = 0
const newEntryID = () => `${Date.now()}-${++lastEntryID}`

// Segna un'operazione da rifare. Senza un accesso non c'è niente da rifare:
// le operazioni sul calendario passano tutte da una Cloud Function.
export const queueCalendarRepair = entry => {
	const uid = auth?.currentUser?.uid
	if (!uid) return
	writeCalendarQueue(uid, withCalendarRepair(readCalendarQueue(uid), { ...entry, id: newEntryID() }))
}

// Si rilegge la coda ogni volta: mentre la si svuota l'app può aggiungerne.
export const removeCalendarRepair = (uid, id) =>
	writeCalendarQueue(
		uid,
		readCalendarQueue(uid).filter(entry => entry.id !== id),
	)

export const countCalendarFailure = (uid, id) =>
	writeCalendarQueue(
		uid,
		readCalendarQueue(uid)
			.map(entry => (entry.id === id ? { ...entry, attempts: (entry.attempts ?? 0) + 1 } : entry))
			.filter(entry => entry.attempts < MAX_CALENDAR_ATTEMPTS),
	)
